
import React, { useState } from "react"

const TransparencySection = ({ tool, handleChange }) => {
    const [sliderValue, setSliderValue] = useState(() => {
        const saved = parseFloat(tool?.transparency);
        return Number.isFinite(saved) ? Math.round(saved * 100) : 100;
    });

    const onSliderChange = (event) => {
        const value = event.target.value;
        setSliderValue(value);
        handleChange({ target: { name: 'transparency', value: value / 100 } });
    };


    return (
        <div className="transparency-section justify-content-between d-flex">
            <div className="">
                <p>TRANSPARENCY</p>
            </div>
            <div className="range-slider show-value">
                <input
                    id="slider_input"
                    className="cursor-pointer lb-native-range"
                    type="range"
                    min="0"
                    max="100"
                    name='transparency'
                    value={sliderValue}
                    onChange={onSliderChange}
                />
                <span>{sliderValue} %</span>
            </div>
        </div>
    )
}
export default TransparencySection